import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649134a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-cluster-popup-selected-feature-footer" }
const _hoisted_2 = { class: "dw-cluster-popup-selected-feature-footer__dots" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "3",
  cy: "3",
  r: "3",
  fill: "currentColor"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "dw-cluster-popup-selected-feature-footer__controls" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.83333 11.0834L1.75 7.00008M1.75 7.00008L5.83333 2.91675M1.75 7.00008L12.25 7.00008",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.16667 2.91659L12.25 6.99992M12.25 6.99992L8.16667 11.0833M12.25 6.99992L1.75 6.99992",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuresLength, (i) => {
        return (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["dots__dot", { 'dot--active': (i - 1) === _ctx.featureIndex }]),
          width: "6",
          height: "6",
          viewBox: "0 0 6 6",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_4, 2))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "controls__group",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpenGroup && _ctx.onOpenGroup(...args)))
      }, " Группа "),
      _createElementVNode("div", {
        class: "controls__control",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSelectPrevious && _ctx.onSelectPrevious(...args)))
      }, _hoisted_7),
      _createElementVNode("div", {
        class: "controls__control",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSelectNext && _ctx.onSelectNext(...args)))
      }, _hoisted_9)
    ])
  ]))
}